<script>
export default {
  name: 'ArticleItem',
}
</script>

<script setup>
import {useRouter} from 'vue-router'
const router = useRouter()

const props = defineProps({
  item: {
    type: Object,
    required: true,
    default: null,
  },
})

// articleItemDidClick
const articleItemDidClick = () => {
  const {item} = props

  switch (item.type) {
    // type === 1 公号文章
    case 1: {
      window.open(item.url, '_blank')
      break
    }
    // type === 2 自营详情
    case 2: {
      router.push({
        name: 'carDetail',
        params: {
          id: item.url,
        },
      })
      break
    }
    // type === 3 文章
    case 3: {
      router.push({
        name: 'ArticleDetail',
        params: {
          id: item.id,
        },
      })
      break
    }
    // type = 4 custom url
    case 4: {
      window.open(item.h5_url, '_self')
      break
    }
    // type === 5 诺圈详情
    case 5: {
      router.push({
        name: 'NuoMomentPostDetail',
        params: {
          postId: item.gid,
        },
      })
      break
    }
    default: {
      break
    }
  }
}
</script>

<template>
  <div
    class="article-item-wrapper"
    @click.prevent.stop="articleItemDidClick">
    <img
      class="article-cover-el"
      :src="item.cover"
      :alt="item.title">
  </div>
</template>

<style lang="scss" scoped="">
.article-item-wrapper {
  display: block;
  width: 100%;
  height: auto;
  position: relative;

  &:hover {
    cursor: pointer;
  }
}

.article-item-wrapper::before {
  content: '';
  width: 100%;
  display: block;
  padding-bottom: calc(100% / (395 / 93));
  box-sizing: border-box;
}

.article-item-wrapper .article-cover-el {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (min-width: 640px) {
  .article-item-wrapper::before {
    content: '';
    width: 100%;
    display: block;
    padding-bottom: calc(640px / (395 / 93));
    box-sizing: border-box;
  }
}
</style>
